import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DataFetch from "./DataFetch";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";
import {
  getCurrentFYByDate,
  minutesToHHMM,
  timeToSeconds,
} from "../../Utilitie";
import { useGlobalContext } from "../../Context/GlobalContext";
import { fetchGrantedNotOptions, fetchAvailedNotOptions } from "./UpdateHalper";
import { FiPlusCircle } from "react-icons/fi";

const defaultData = {
  Direction: "",
  From_Station: "",
  To_Station: "",
  Section_Yard: "",
  Corridore: "",
  Department: "",
  Section: "",
  Type: "",
  Asset: "",
  Block_Type: "",
  No_Of_Demand_By_Engg: 0,
  Engg_Demand: "00:00",
  No_Of_Demand_Agreed_GIVEN: 0,
  Agreed_Demand: "00:00",
  GrantedFrom: "00:00",
  GrantedTo: "00:00",
  Granted_Duration: "00:00",
  Availed_From: "00:00",
  Availed_To: "00:00",
  Availed: "00:00",
  Burst: "",
  Actual_Output_in_Meter: "",
  Actual_Output: "",
  Remarks: "",
  Granted_Not: "NOT GRANTED",
  Availed_Not: "NOT AVAILED",
  Reason: "",
  Rolling_Block: "Rolling Block",
};

const defaultDynamicOptions = {
  Type: [],
  Asset: [],
  Block_Type: [],
  From_Station: [],
  To_Station: [],
};

const Insert = ({ selectedDate, setDataChanged }) => {
  const { userData } = useGlobalContext();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [entryCount, setEntryCount] = useState(1);
  const [entries, setEntries] = useState([]);
  const [reportDate, setReportDate] = useState(selectedDate?.date || "");
  const [sectionsData, setSectionsData] = useState([]);
  const [defaultSection, setDefaultSection] = useState("");
  const [defaultDepart, setDefaultDepart] = useState("");
  const [machineData, setMachineData] = useState([]);
  const [result, setResult] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newRowLoading, setNewRowLoading] = useState(false);
  const [error, setError] = useState(false);
  const [stationData, setStationData] = useState(null);

  const inputRefs = useRef([]);
  const [grantedNotOptions, setGrantedNotOptions] = useState([
    {
      Sno: 35,
      table_option_for_insertion: "Loading",
      tabel_path: "B_Granted_Not",
    },
  ]);
  const [availedNotOptions, setAvailedNotOptions] = useState([
    {
      Sno: 35,
      table_option_for_insertion: "Loading",
      tabel_path: "B_Granted_Not",
    },
  ]);
  useEffect(() => {
    const loadData = async () => {
      const data = await fetchGrantedNotOptions();
      setGrantedNotOptions(data);
      const data2 = await fetchAvailedNotOptions();
      setAvailedNotOptions(data2);
    };
    loadData();
  }, []);
  const fetchSection = async () => {
    try {
      const response = await axios.get(`${urlPrefixBlock}getstationcode`);

      if (response.data.status === "ok") {
        const fetchedData = response.data.data;
        setStationData(fetchedData);
      }
      return [];
    } catch (err) {
      console.error(`Failed to fetch stations for section:`, err);
      setError(true);
      return [];
    }
  };

  const fetchStationsForSection = (section) => {
    if (stationData) {
      const uniqueByName = Array.from(
        new Map(stationData.map((obj) => [obj.id, obj])).values(),
      );
      const filteredAndSorted = uniqueByName
        .filter((obj) => obj.section === section)
        .sort((a, b) => a.station.localeCompare(b.station));
      return filteredAndSorted.map((obj) => obj.station);
    }
    return [];
  };

  useEffect(() => {
    fetchSection();
    setReportDate(selectedDate?.date || "");
  }, [selectedDate]);

  const fetchMachineData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlPrefixBlock}getmachinetype`);
      if (response.data.status === "ok") {
        setMachineData(response.data.machineTypes);
      }
    } catch (err) {
      console.error("Failed to fetch machine types:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMachineData();
  }, []);

  const visibleKeys = [
    "Section",
    "Direction",
    "From_Station",
    "To_Station",
    "Section_Yard",
    "Corridore",
    "Department",
    "Type",
    "Asset",
    "Block_Type",
    "No_Of_Demand_By_Engg",
    "Engg_Demand",
    "No_Of_Demand_Agreed_GIVEN",
    "Agreed_Demand",
    "GrantedFrom",
    "GrantedTo",
    "Granted_Duration",
    "Availed_From",
    "Availed_To",
    "Availed",
    "Burst",
    "Actual_Output_in_Meter",
    "Actual_Output",
    "Remarks",
    "Granted_Not",
    "Availed_Not",
    "Reason",
    "Rolling_Block",
  ];

  useEffect(() => {
    if (!machineData.length || !sectionsData.length) return;

    const initializeEntries = async () => {
      setNewRowLoading(true);
      const newEntries = await Promise.all(
        Array.from({ length: entryCount }, async (_, index) => {
          const existingEntry = entries[index];
          const selectedDept = machineData.find(
            (dept) =>
              dept.DEPARTMENT ===
              (existingEntry?.selections.Department || defaultDepart),
          );

          let sectionToUse = defaultSection || sectionsData[0] || "";
          if (existingEntry && existingEntry.selections.Section) {
            sectionToUse = existingEntry.selections.Section;
          }

          const stationOptions = await fetchStationsForSection(sectionToUse);

          if (existingEntry) {
            return {
              ...existingEntry,
              dynamicOptions: {
                ...existingEntry.dynamicOptions,
                From_Station: stationOptions,
                To_Station: stationOptions,
                Reason: grantedNotOptions.map(
                  (obj) => obj.table_option_for_insertion,
                ),
              },
            };
          }

          return {
            selections: {
              ...defaultData,
              Department: defaultDepart,
              Section: defaultSection,
              inserted_by: userData.id,
            },
            dynamicOptions: {
              Type: selectedDept?.children.map((child) => child.TYPE) || [],
              Asset: [],
              Block_Type: [],
              From_Station: stationOptions,
              To_Station: stationOptions,
              Reason: grantedNotOptions.map(
                (obj) => obj.table_option_for_insertion,
              ),
            },
          };
        }),
      );

      console.log(newEntries);
      setEntries(newEntries);
      inputRefs.current = Array(entryCount)
        .fill()
        .map(() => Array(visibleKeys.length).fill(null));
      setNewRowLoading(false);
    };

    initializeEntries();
  }, [entryCount, defaultSection, machineData, sectionsData]);
  useEffect(() => {
    if (!machineData.length || !defaultDepart) return;

    setEntries((prevEntries) =>
      prevEntries.map((entry, index) => {
        const currentDepartment = entry.selections.Department || defaultDepart;
        const selectedDept = machineData.find(
          (dept) => dept.DEPARTMENT === currentDepartment,
        );
        const shouldUpdateDepartment =
          index >= entries.length || !entry.selections.Department;
        const shouldUpdateSection =
          index >= entries.length || !entry.selections.Section;

        const typeOptions =
          selectedDept?.children.map((child) => child.TYPE) || [];
        const isValidType = typeOptions.includes(entry.selections.Type);

        const selectedType = selectedDept?.children.find(
          (child) => child.TYPE === entry.selections.Type,
        );
        const assetOptions =
          selectedType?.children.map((asset) => asset.ASSET) || [];
        const isValidAsset = assetOptions.includes(entry.selections.Asset);

        const selectedAsset = selectedType?.children.find(
          (asset) => asset.ASSET === entry.selections.Asset,
        );
        const blockTypeOptions =
          selectedAsset?.data.map((item) => item.ASSET_DISCRIPTION) || [];
        const isValidBlockType = blockTypeOptions.includes(
          entry.selections.Block_Type,
        );

        // Determine Reason options based on Granted_Duration and Availed
        const reasonOptions =
          entry.selections.Granted_Duration === "00:00"
            ? grantedNotOptions.map((obj) => obj.table_option_for_insertion)
            : entry.selections.Availed === "00:00"
              ? availedNotOptions.map((obj) => obj.table_option_for_insertion)
              : [];

        return {
          ...entry,
          selections: {
            ...entry.selections,
            Department: shouldUpdateDepartment
              ? defaultDepart
              : entry.selections.Department,
            Section: shouldUpdateSection
              ? defaultSection
              : entry.selections.Section,
            Type: isValidType ? entry.selections.Type : "",
            Asset: isValidAsset ? entry.selections.Asset : "",
            Block_Type: isValidBlockType ? entry.selections.Block_Type : "",
            Reason: reasonOptions.includes(entry.selections.Reason)
              ? entry.selections.Reason
              : "",
          },
          dynamicOptions: {
            ...entry.dynamicOptions,
            Type: typeOptions,
            Asset: isValidType ? assetOptions : [],
            Block_Type: isValidAsset ? blockTypeOptions : [],
            Reason: reasonOptions,
          },
        };
      }),
    );
  }, [defaultDepart, machineData, defaultSection]);
  const staticOptions = {
    Section: sectionsData,
    Section_Yard: ["Section", "Yard"],
    Direction: [
      "BOTH",
      "CHORD LINE",
      "DOWN",
      "SINGLE LINE",
      "THIRD",
      "UP",
      "UP GS",
      "UDL",
    ],
    Corridore: ["Corridor", "Non-Corridor", "****"],
    No_Of_Demand_By_Engg: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    Engg_Demand: [],
    No_Of_Demand_Agreed_GIVEN: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    Agreed_Demand: [],
    GrantedFrom: [],
    GrantedTo: [],
    Granted_Duration: [],
    Availed_From: [],
    Availed_To: [],
    Availed: [],
    Burst: ["Burst", "Not Burst"],
    Actual_Output: [],
    Actual_Output_in_Meter: [],
    Remarks: [],
    Granted_Not: ["GRANTED", "NOT GRANTED"],
    Availed_Not: ["AVAILED", "NOT AVAILED"],
    Reason: [], // Will be dynamically set in handleChange
    Rolling_Block: ["Rolling Block", "Non Rolling Block", "--"],
    Department: machineData.map((dept) => dept.DEPARTMENT),
  };

  const handleChange = async (formIndex, key, value) => {
    if (formIndex >= entryCount) return;
    const updatedEntries = [...entries];

    if (
      [
        "Engg_Demand",
        "Agreed_Demand",
        "GrantedFrom",
        "GrantedTo",
        "Availed_From",
        "Availed_To",
        "Availed",
      ].includes(key)
    ) {
      if (value && !/^[0-2][0-9]:[0-5][0-9]$/.test(value)) {
        return;
      }
    }

    updatedEntries[formIndex].selections[key] = value;

    if (key === "Section") {
      const stationOptions = await fetchStationsForSection(value);
      updatedEntries[formIndex].dynamicOptions = {
        ...updatedEntries[formIndex].dynamicOptions,
        From_Station: stationOptions,
        To_Station: stationOptions,
      };
      updatedEntries[formIndex].selections.From_Station = "";
      updatedEntries[formIndex].selections.To_Station = "";
    }

    if (key === "Department") {
      const selectedDept = machineData.find(
        (dept) => dept.DEPARTMENT === value,
      );
      updatedEntries[formIndex].dynamicOptions = {
        ...updatedEntries[formIndex].dynamicOptions,
        Type: selectedDept?.children.map((child) => child.TYPE) || [],
        Asset: [],
        Block_Type: [],
      };
      updatedEntries[formIndex].selections.Type = "";
      updatedEntries[formIndex].selections.Asset = "";
      updatedEntries[formIndex].selections.Block_Type = "";
    }

    if (key === "Type") {
      const selectedDept = machineData.find(
        (dept) =>
          dept.DEPARTMENT === updatedEntries[formIndex].selections.Department,
      );
      const selectedType = selectedDept?.children.find(
        (child) => child.TYPE === value,
      );
      updatedEntries[formIndex].dynamicOptions = {
        ...updatedEntries[formIndex].dynamicOptions,
        Asset: selectedType?.children.map((asset) => asset.ASSET) || [],
        Block_Type: [],
      };
      updatedEntries[formIndex].selections.Asset = "";
      updatedEntries[formIndex].selections.Block_Type = "";
    }

    if (key === "Asset") {
      const selectedDept = machineData.find(
        (dept) =>
          dept.DEPARTMENT === updatedEntries[formIndex].selections.Department,
      );
      const selectedType = selectedDept?.children.find(
        (child) => child.TYPE === updatedEntries[formIndex].selections.Type,
      );
      const selectedAsset = selectedType?.children.find(
        (asset) => asset.ASSET === value,
      );
      updatedEntries[formIndex].dynamicOptions = {
        ...updatedEntries[formIndex].dynamicOptions,
        Block_Type:
          selectedAsset?.data.map((item) => item.ASSET_DISCRIPTION) || [],
      };
      updatedEntries[formIndex].selections.Block_Type = "";
    }

    if (key === "GrantedFrom") {
      updatedEntries[formIndex].selections.Availed_From = value;
    }
    if (key === "GrantedTo") {
      updatedEntries[formIndex].selections.Availed_To = value;
    }

    if (
      updatedEntries[formIndex].selections.GrantedFrom &&
      updatedEntries[formIndex].selections.GrantedTo
    ) {
      let a = timeToSeconds(updatedEntries[formIndex].selections.GrantedFrom);
      let b = timeToSeconds(updatedEntries[formIndex].selections.GrantedTo);
      let c;
      if (a > b) {
        c = minutesToHHMM((b - a + 86400) / 60);
      } else {
        c = minutesToHHMM((b - a) / 60);
      }
      updatedEntries[formIndex].selections.Granted_Duration = c;
    } else {
      updatedEntries[formIndex].selections.Granted_Duration = "00:00";
    }

    if (
      updatedEntries[formIndex].selections.Availed_From &&
      updatedEntries[formIndex].selections.Availed_To
    ) {
      let a = timeToSeconds(updatedEntries[formIndex].selections.Availed_From);
      let b = timeToSeconds(updatedEntries[formIndex].selections.Availed_To);
      let c;
      if (a > b) {
        c = minutesToHHMM((b - a + 86400) / 60);
      } else {
        c = minutesToHHMM((b - a) / 60);
      }
      updatedEntries[formIndex].selections.Availed = c;
    } else {
      updatedEntries[formIndex].selections.Availed = "00:00";
    }

    if (
      updatedEntries[formIndex].selections.Availed &&
      updatedEntries[formIndex].selections.Granted_Duration
    ) {
      updatedEntries[formIndex].selections.Burst =
        updatedEntries[formIndex].selections.Availed <=
        updatedEntries[formIndex].selections.Granted_Duration
          ? "Not Burst"
          : "Burst";
    } else {
      updatedEntries[formIndex].selections.Burst = "";
    }

    if (
      updatedEntries[formIndex].selections.From_Station &&
      updatedEntries[formIndex].selections.To_Station
    ) {
      updatedEntries[formIndex].selections.Section_Yard =
        updatedEntries[formIndex].selections.From_Station ===
        updatedEntries[formIndex].selections.To_Station
          ? "Yard"
          : "Section";
    } else {
      updatedEntries[formIndex].selections.Section_Yard = "";
    }

    const { GrantedFrom, GrantedTo, Granted_Duration } =
      updatedEntries[formIndex].selections;
    updatedEntries[formIndex].selections.Granted_Not =
      // !GrantedFrom ||
      // GrantedFrom === "00:00" ||
      // !GrantedTo ||
      // GrantedTo === "00:00" ||
      !Granted_Duration || Granted_Duration === "00:00"
        ? "NOT GRANTED"
        : "GRANTED";

    const { Availed_From, Availed_To, Availed } =
      updatedEntries[formIndex].selections;
    updatedEntries[formIndex].selections.Availed_Not =
      // !Availed_From ||
      // Availed_From === "00:00" ||
      // !Availed_To ||
      // Availed_To === "00:00" ||
      !Availed || Availed === "00:00" ? "NOT AVAILED" : "AVAILED";

    // Update Reason options based on Granted_Duration and Availed
    if (
      key === "GrantedFrom" ||
      key === "GrantedTo" ||
      key === "Availed_From" ||
      key === "Availed_To"
    ) {
      const reasonOptions =
        updatedEntries[formIndex].selections.Granted_Duration === "00:00"
          ? grantedNotOptions.map((obj) => obj.table_option_for_insertion)
          : updatedEntries[formIndex].selections.Availed === "00:00"
            ? availedNotOptions.map((obj) => obj.table_option_for_insertion)
            : [];
      updatedEntries[formIndex].dynamicOptions = {
        ...updatedEntries[formIndex].dynamicOptions,
        Reason: reasonOptions,
      };
      updatedEntries[formIndex].selections.Reason = reasonOptions.includes(
        updatedEntries[formIndex].selections.Reason,
      )
        ? updatedEntries[formIndex].selections.Reason
        : "";
    }

    if (key === "No_Of_Demand_By_Engg" || key === "No_Of_Demand_Agreed_GIVEN") {
      if (
        updatedEntries[formIndex].selections.No_Of_Demand_By_Engg == 0 &&
        updatedEntries[formIndex].selections.No_Of_Demand_Agreed_GIVEN !== 0
      ) {
        updatedEntries[formIndex].selections.Rolling_Block =
          "Non Rolling Block";
      } else {
        updatedEntries[formIndex].selections.Rolling_Block = "Rolling Block";
      }
    }
    if (key === "Rolling_Block") {
      updatedEntries[formIndex].selections.Rolling_Block =
        value || "Rolling Block";
    }
    if (key === "Reason") {
      updatedEntries[formIndex].selections.Reason = value || "";
    }

    setEntries(updatedEntries);
  };

  const addRowBelow = async (index) => {
    setNewRowLoading(true);
    const sectionToUse = defaultSection || sectionsData[0] || "";
    const stationOptions = await fetchStationsForSection(sectionToUse);
    const selectedDept = machineData.find(
      (dept) => dept.DEPARTMENT === defaultDepart,
    );
    const newEntry = {
      selections: {
        ...defaultData,
        Department: defaultDepart,
        Section: sectionToUse,
        inserted_by: userData.id,
      },
      dynamicOptions: {
        Type: selectedDept?.children.map((child) => child.TYPE) || [],
        Asset: [],
        Block_Type: [],
        From_Station: stationOptions,
        To_Station: stationOptions,
        Reason: [], // Initialize with empty Reason options
      },
    };
    const newEntries = [...entries];
    newEntries.splice(index + 1, 0, newEntry);
    setEntries(newEntries);
    const newRefs = [...inputRefs.current];
    newRefs.splice(index + 1, 0, Array(visibleKeys.length).fill(null));
    inputRefs.current = newRefs;
    setEntryCount(newEntries.length);
    setNewRowLoading(false);
  };

  const removeRow = (index) => {
    if (entries.length <= 1) return;
    const newEntries = [...entries];
    newEntries.splice(index, 1);
    setEntries(newEntries);
    const newRefs = [...inputRefs.current];
    newRefs.splice(index, 1);
    inputRefs.current = newRefs;
    setEntryCount(newEntries.length);
  };

  const handleClearAll = async () => {
    if (!machineData.length) {
      setEntries(
        Array.from({ length: entryCount }, () => ({
          selections: {
            ...defaultData,
            Department: defaultDepart,
            Section: defaultSection || "",
          },
          dynamicOptions: {
            ...defaultDynamicOptions,
            Reason: grantedNotOptions.map(
              (obj) => obj.table_option_for_insertion,
            ),
          },
        })),
      );
    } else {
      const selectedDept = machineData.find(
        (dept) => dept.DEPARTMENT === defaultDepart,
      );
      setEntries(
        await Promise.all(
          Array.from({ length: entryCount }, async () => {
            const stationOptions = await fetchStationsForSection(
              defaultSection || "",
            );
            return {
              selections: {
                ...defaultData,
                Department: defaultDepart,
                Section: defaultSection || "",
              },
              dynamicOptions: {
                Type: selectedDept?.children.map((child) => child.TYPE) || [],
                Asset: [],
                Block_Type: [],
                From_Station: stationOptions,
                To_Station: stationOptions,
                Reason: [],
              },
            };
          }),
        ),
      );
    }
    inputRefs.current = Array(entryCount)
      .fill()
      .map(() => Array(visibleKeys.length).fill(null));
  };

  const handleSubmit = async () => {
    const allData = entries.map((entry) => {
      const { Asset, ...selectionsWithoutAsset } = entry.selections;
      const currentFy = getCurrentFYByDate(reportDate);
      return {
        reportDate,
        section: entry.selections.Section,
        F_Year: currentFy.FY.replace("_", "-"),
        ...selectionsWithoutAsset,
      };
    });
    try {
      const response = await fetch(`${urlPrefixBlock}insertblockdata`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(allData),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setResult(result);
      setDataChanged((prev) => !prev);
      setShow(true);
      if (!machineData.length) {
        setEntries(
          Array.from({ length: entryCount }, () => ({
            selections: {
              ...defaultData,
              Department: defaultDepart,
              Section: defaultSection || "",
            },
            dynamicOptions: { ...defaultDynamicOptions, Reason: [] },
          })),
        );
      } else {
        const selectedDept = machineData.find(
          (dept) => dept.DEPARTMENT === defaultDepart,
        );
        setEntries(
          await Promise.all(
            Array.from({ length: entryCount }, async () => {
              const stationOptions = await fetchStationsForSection(
                defaultSection || "",
              );
              return {
                selections: {
                  ...defaultData,
                  Department: defaultDepart,
                  Section: defaultSection || "",
                },
                dynamicOptions: {
                  Type: selectedDept?.children.map((child) => child.TYPE) || [],
                  Asset: [],
                  Block_Type: [],
                  From_Station: stationOptions,
                  To_Station: stationOptions,
                  Reason: grantedNotOptions.map(
                    (obj) => obj.table_option_for_insertion,
                  ),
                },
              };
            }),
          ),
        );
      }
      inputRefs.current = Array(entryCount)
        .fill()
        .map(() => Array(visibleKeys.length).fill(null));
    } catch (err) {
      console.error("Error submitting data:", err);
      setResult({ status: "error", message: "Failed to submit data" });
      setShow(true);
    }
  };

  const handleKeyDown = (e, rowIndex, colIndex, key) => {
    if (rowIndex >= entryCount) return;
    const totalRows = entries.length;
    const totalCols = visibleKeys.length;

    let newRow = rowIndex;
    let newCol = colIndex;
    switch (e.key) {
      case "ArrowUp":
        newRow = Math.max(0, rowIndex - 1);
        break;
      case "ArrowDown":
      case "Enter":
        newRow = Math.min(totalRows - 1, rowIndex + 1);
        break;
      case "ArrowLeft":
        newCol = Math.max(
          0,
          colIndex -
            (key === "Corridore" || key === "Actual_Output_in_Meter"
              ? 2
              : key === "No_Of_Demand_By_Engg"
                ? 4
                : key === "Reason"
                  ? 3
                  : 1),
        );
        break;
      case "ArrowRight":
      case "Tab":
        newCol = Math.min(
          totalCols - 1,
          colIndex +
            (key === "To_Station" || key === "Availed"
              ? 2
              : key === "Remarks"
                ? 3
                : 1),
        );
        break;
      default:
        return;
    }

    if (
      ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
    ) {
      e.preventDefault();
    }

    const targetRef = inputRefs.current[newRow]?.[newCol];
    if (targetRef && !targetRef.disabled) {
      targetRef.focus();
    }
  };

  const renderAllOption = (key, formIndex, entry, colIndex) => {
    if (formIndex >= entryCount) return null;
    const activeDepartment = entry.selections.Department || defaultDepart;
    const activeType = entry.selections.Type || "";
    const activeAsset = entry.selections.Asset || "";
    const allOptions = { ...staticOptions, ...entry.dynamicOptions };
    if (key === "Section") {
      return (
        <select
          ref={(el) => {
            if (inputRefs.current[formIndex]) {
              inputRefs.current[formIndex][colIndex] = el;
            }
          }}
          className="form-select form-select-sm"
          style={{ width: "120px" }}
          value={entry.selections[key] || ""}
          onChange={(e) => handleChange(formIndex, key, e.target.value)}
          onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
        >
          <option value="">Select Section</option>
          {allOptions.Section.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      );
    }

    if (key === "Department") {
      return (
        <select
          ref={(el) => {
            if (inputRefs.current[formIndex]) {
              inputRefs.current[formIndex][colIndex] = el;
            }
          }}
          className="form-select form-select-sm"
          style={{ width: "120px" }}
          value={entry.selections[key] || defaultDepart}
          onChange={(e) => handleChange(formIndex, key, e.target.value)}
          onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
        >
          <option value="">Select</option>
          {allOptions.Department.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      );
    }

    if (key === "Type") {
      return (
        <select
          ref={(el) => {
            if (inputRefs.current[formIndex]) {
              inputRefs.current[formIndex][colIndex] = el;
            }
          }}
          className="form-select form-select-sm"
          value={entry.selections[key] || ""}
          onChange={(e) => handleChange(formIndex, key, e.target.value)}
          disabled={!activeDepartment}
          onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
        >
          <option value="">Select</option>
          {allOptions.Type.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      );
    }

    if (key === "Asset") {
      return (
        <select
          ref={(el) => {
            if (inputRefs.current[formIndex]) {
              inputRefs.current[formIndex][colIndex] = el;
            }
          }}
          className="form-select form-select-sm"
          value={entry.selections[key] || ""}
          onChange={(e) => handleChange(formIndex, key, e.target.value)}
          disabled={!activeType}
          onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
        >
          <option value="">Select</option>
          {allOptions.Asset.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      );
    }

    if (key === "Block_Type") {
      return (
        <select
          ref={(el) => {
            if (inputRefs.current[formIndex]) {
              inputRefs.current[formIndex][colIndex] = el;
            }
          }}
          className="form-select form-select-sm"
          value={entry.selections[key] || ""}
          style={{ width: "120px" }}
          onChange={(e) => handleChange(formIndex, key, e.target.value)}
          disabled={!activeAsset}
          onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
        >
          <option value="">Select</option>
          {allOptions.Block_Type.filter((f) => f !== "PQRS")
            .sort((a, b) => a.localeCompare(b))
            .map((opt, i) => (
              <option key={i} value={opt}>
                {opt}
              </option>
            ))}
        </select>
      );
    }

    if (key === "From_Station" || key === "To_Station") {
      return (
        <select
          ref={(el) => {
            if (inputRefs.current[formIndex]) {
              inputRefs.current[formIndex][colIndex] = el;
            }
          }}
          className="form-select form-select-sm"
          value={entry.selections[key] || ""}
          onChange={(e) => handleChange(formIndex, key, e.target.value)}
          disabled={!entry.selections.Section}
          onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
        >
          <option value="">Select</option>
          {allOptions[key].map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      );
    }

    if (key === "Granted_Not" || key === "Availed_Not") {
      return (
        <input
          ref={(el) => {
            if (inputRefs.current[formIndex]) {
              inputRefs.current[formIndex][colIndex] = el;
            }
          }}
          className="form-control form-control-sm"
          style={{
            height: "26px",
            padding: "2px 6px",
            fontSize: "0.8rem",
          }}
          value={entry.selections[key] || ""}
          disabled
          onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
        />
      );
    }

    if (key === "Reason") {
      return (
        <select
          ref={(el) => {
            if (inputRefs.current[formIndex]) {
              inputRefs.current[formIndex][colIndex] = el;
            }
          }}
          className="form-select form-select-sm"
          value={entry.selections[key] || ""}
          onChange={(e) => handleChange(formIndex, key, e.target.value)}
          disabled={!allOptions.Reason.length}
          onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
        >
          <option value="">Select</option>
          {allOptions.Reason.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      );
    }

    return (
      <select
        ref={(el) => {
          if (inputRefs.current[formIndex]) {
            inputRefs.current[formIndex][colIndex] = el;
          }
        }}
        className="form-select form-select-sm"
        value={entry.selections[key] || ""}
        onChange={(e) => handleChange(formIndex, key, e.target.value)}
        onKeyDown={(e) => handleKeyDown(e, formIndex, colIndex, key)}
      >
        <option value="">Select</option>
        {allOptions[key]?.map((opt, i) => (
          <option key={i} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    );
  };

  return (
    <div className="papaDiv" style={{ fontSize: "12px" }}>
      {error && (
        <div className="alert alert-danger" role="alert">
          Failed to fetch data. Please try again later.
        </div>
      )}

      <div className="mb-3">
        <div
          className="card border-0 shadow-sm mb-3"
          style={{ borderRadius: "12px", overflow: "hidden" }}
        >
          <div
            className="card-body p-3"
            style={{
              background:
                "linear-gradient(110deg, #063b87 0%, #0a57bb 65%, #087344 100%)",
            }}
          >
            <div className="d-flex flex-column flex-xl-row justify-content-between align-items-xl-center gap-3">
              {/* Header Title */}
              <div className="d-flex align-items-center gap-2">
                <div
                  className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
                  style={{
                    width: "42px",
                    height: "42px",
                    background: "rgba(255,255,255,0.16)",
                    color: "#fff",
                    fontSize: "21px",
                  }}
                >
                  <FiPlusCircle />
                </div>

                <div>
                  <h6 className="text-white fw-bold mb-1">Insert Block Data</h6>
                  <div className="text-white-50 small">
                    Report Date:{" "}
                    <span className="text-white fw-semibold">{reportDate}</span>
                  </div>
                </div>
              </div>

              {/* Controls */}
              <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-between gap-3 rounded-3 px-3 py-2"
                  style={{ background: "rgba(255,255,255,0.12)" }}
                >
                  <label
                    htmlFor="entryCount"
                    className="text-white small fw-semibold text-nowrap mb-0"
                  >
                    Number of Entries
                  </label>

                  <input
                    id="entryCount"
                    type="number"
                    min="1"
                    max="23"
                    className="form-control form-control-sm fw-semibold"
                    style={{
                      width: "75px",
                      background: "#fff",
                      color: "#063b87",
                      border: "none",
                      borderRadius: "7px",
                    }}
                    value={entryCount}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "") {
                        setEntryCount("");
                      } else {
                        setEntryCount(Math.min(23, Math.max(1, Number(value))));
                      }
                    }}
                    onBlur={() => {
                      if (!entryCount || Number(entryCount) < 1) {
                        setEntryCount(1);
                      }
                    }}
                  />
                </div>

                <div className="d-flex align-items-center">
                  <DataFetch
                    entriesLength={entries.length}
                    defaultDepart={defaultDepart}
                    setDefaultDepart={setDefaultDepart}
                    machineData={machineData}
                    setReportDate={setReportDate}
                    reportDate={reportDate}
                    section={defaultSection}
                    setSectionsData={setSectionsData}
                    setSection={setDefaultSection}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {defaultSection === "" || defaultDepart === "" ? (
        <div className="alert alert-info" role="alert">
          Please select both section and department to proceed.
        </div>
      ) : (
        <div className="table-responsive papaDivNM">
          <table className="table table-bordered table-striped mb-4 ms-0 ps-0 align-middle excel-table border">
            <thead className="table-dark">
              <tr>
                <th rowSpan={2} style={{ minWidth: "80px" }}>
                  Actions
                </th>
                <th
                  rowSpan={2}
                  style={{ minWidth: "90px" }}
                  className="sticky-col"
                >
                  Date
                </th>
                {visibleKeys.map((key) => {
                  if (key === "No_Of_Demand_Agreed_GIVEN") {
                    return (
                      <th
                        key={key}
                        className="text-wrap text-center"
                        colSpan={2}
                      >
                        Demand Agreed
                      </th>
                    );
                  }
                  if (key === "No_Of_Demand_By_Engg") {
                    return (
                      <th
                        key={key}
                        className="text-wrap text-center"
                        colSpan={2}
                      >
                        Demand by Engg
                      </th>
                    );
                  }
                  if (key === "GrantedFrom") {
                    return (
                      <th
                        key={key}
                        className="text-wrap text-center"
                        colSpan={3}
                      >
                        Granted
                      </th>
                    );
                  }
                  if (key === "Availed_From") {
                    return (
                      <th
                        key={key}
                        className="text-wrap text-center"
                        colSpan={3}
                      >
                        Availed
                      </th>
                    );
                  }
                  if (key === "Actual_Output") {
                    return (
                      <th
                        key={key}
                        className="text-wrap text-center"
                        colSpan={2}
                      >
                        Actual Output
                      </th>
                    );
                  }
                  if (
                    [
                      "GrantedTo",
                      "Granted_Duration",
                      "Availed_To",
                      "Availed",
                      "Agreed_Demand",
                      "Engg_Demand",
                      "Actual_Output_in_Meter",
                    ].includes(key)
                  ) {
                    return null;
                  }
                  return (
                    <th
                      key={key}
                      className="text-wrap text-center"
                      rowSpan={2}
                      style={{
                        minWidth: `${
                          key === "Direction" || key === "Section_Yard"
                            ? "70px"
                            : key === "Section"
                              ? "120px"
                              : "100px"
                        }`,
                      }}
                    >
                      {key === "Corridore"
                        ? "Corridor"
                        : key.replace(/_/g, " ")}
                    </th>
                  );
                })}
              </tr>
              <tr>
                <th>no.</th>
                <th>hrs.</th>
                <th>no.</th>
                <th>hrs.</th>
                <th>From</th>
                <th>To</th>
                <th>Duration</th>
                <th>From</th>
                <th>To</th>
                <th>Duration</th>
                <th>In Meters</th>
                <th>Remark</th>
              </tr>
            </thead>
            <tbody style={{ margin: "0px", padding: "0px" }}>
              {entries.map((entry, formIndex) => (
                <tr
                  key={formIndex}
                  className={`${
                    selectedIndex === formIndex ? "activeTr" : ""
                  } activeTableTr`}
                >
                  <td
                    style={{
                      minWidth: "80px",
                      textAlign: "center",
                      background: "rgba(156, 155, 155, 0.63)",
                    }}
                  >
                    <button
                      className="btn btn-sm btn-success me-1"
                      onClick={() => addRowBelow(formIndex)}
                    >
                      +
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => removeRow(formIndex)}
                    >
                      -
                    </button>
                  </td>
                  <td
                    style={{
                      minWidth: "90px",
                      margin: "0px",
                      padding: "0px",
                      cursor: "pointer",
                      background: "rgba(156, 155, 155)",
                      zIndex: 10,
                    }}
                    className="sticky-col"
                    onClick={() => {
                      setSelectedIndex(formIndex);
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSelectedIndex(formIndex);
                      }}
                    >
                      {/* {reportDate} */}
                      {reportDate.slice(8, 10)}-{reportDate.slice(5, 7)}-
                      {reportDate.slice(0, 4)}
                    </div>
                  </td>
                  {visibleKeys.map((key, colIndex) => {
                    const isInputField = [
                      "Actual_Output",
                      "Actual_Output_in_Meter",
                      "Remarks",
                      "Engg_Demand",
                      "Agreed_Demand",
                      "GrantedFrom",
                      "GrantedTo",
                      "Granted_Duration",
                      "Availed_From",
                      "Availed_To",
                      "Availed",
                    ].includes(key);

                    const inputType =
                      key === "Actual_Output_in_Meter"
                        ? "number"
                        : key === "Actual_Output" || key === "Remarks"
                          ? "text"
                          : "time";

                    return (
                      <td
                        key={key}
                        style={{
                          minWidth: `${
                            key === "Direction" || key === "Section_Yard"
                              ? "70px"
                              : key === "Section"
                                ? "120px"
                                : "90px"
                          }`,
                        }}
                      >
                        {key === "Section_Yard" || key === "Burst" ? (
                          <input
                            ref={(el) => {
                              if (inputRefs.current[formIndex]) {
                                inputRefs.current[formIndex][colIndex] = el;
                              }
                            }}
                            className="form-control form-control-sm"
                            style={{
                              padding: "2px 6px",
                              fontSize: "0.8rem",
                            }}
                            value={entry.selections[key] || ""}
                            disabled
                            onKeyDown={(e) =>
                              handleKeyDown(e, formIndex, colIndex, key)
                            }
                          />
                        ) : isInputField ? (
                          <input
                            ref={(el) => {
                              if (inputRefs.current[formIndex]) {
                                inputRefs.current[formIndex][colIndex] = el;
                              }
                            }}
                            type={inputType}
                            className="form-control form-control-sm"
                            style={{
                              width: "100px",
                              padding: "2px 6px",
                              fontSize: "0.8rem",
                            }}
                            value={entry.selections[key] || ""}
                            onChange={(e) =>
                              handleChange(formIndex, key, e.target.value)
                            }
                            onKeyDown={(e) =>
                              handleKeyDown(e, formIndex, colIndex, key)
                            }
                          />
                        ) : (
                          renderAllOption(key, formIndex, entry, colIndex)
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
          {newRowLoading && (
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="text-center mt-4">
        <button
          className="btn btn-outline-danger m-2 px-5"
          onClick={handleClearAll}
        >
          Clear All
        </button>
        <button
          className="btn btn-outline-success m-2 px-5"
          onClick={() => {
            const confirmChange = window.confirm(
              `Are you sure to insert data for date ${selectedDate.date} ?`,
            );

            if (confirmChange) {
              handleSubmit();
            }
          }}
          disabled={entries.some((entry) => !entry.selections.Section)}
        >
          Insert Data
        </button>
        <div className="p-3">
          {result && result.status === "ok" ? (
            <SuccessMsg
              head="Success"
              message={result.message}
              show={show}
              setShow={setShow}
            />
          ) : (
            <FailedMsg
              head="Failed"
              message={result?.message || "Failed to complete the task"}
              show={show}
              setShow={setShow}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Insert;
